<template>
  <pdf-a4-page no-margin :pdf-key="lang" v-for="(anmerkungPage, key) in getAnmerkungenPages(ba)" :key="key">
    <div class="landingpage-background w-screen h-screen">
      <div class="flex flex-col justify-between" style="height: 1020px">
        <tng-header :ba="ba" :immobilie="immobilie" :lang="lang"/>
        <div class="text-xs text-gray-500">Karte > Anmerkungen des Gutachters</div>
        <div class="text-xl md:text-xl font-bold">Anmerkungen auf der Karte</div>
        <div class="content h-full max-h-full">
          <div v-if="anmerkungPage['anmerkungen'].length > 0 " class="ml-2" >
            <div
              v-for="(anmerkung, key) in anmerkungPage['anmerkungen'].slice(1)"
              :key="key"
              style="
                border-style: solid;
                border-color: var(--white100) var(--white100) var(--white100) rgb(216, 215, 26);
                border-radius: 5px;
              "
              class="mt-2"
            >
              <div class="ml-2 text-xs">
                Titel:
                <span class="text-xs text-gray-500">{{ anmerkung.title }}</span>
              </div>
              <div class="text-xs md:text-xs ml-2">
                Anmerkung:
                <span class="text-xs text-gray-500">{{
                  anmerkung.anmerkung
                }}</span>
              </div>
              <oneto-five-image-div
                :ba="ba"
                :immobilie="immobilie"
                :fragesPath="undefined"
                :lang="lang"
                :imageObjects="anmerkung.bilder"
                class="ml-2 col-span-8"
              />
            </div>
          </div>
          <div v-else class="justify-center items-center col-span-5 mt-1"
            style="
              background-color: rgb(235, 239, 240);
              border-style: solid;
              border-color: rgb(235, 239, 240) rgb(235, 239, 240) rgb(235, 239, 240)
                rgb(235, 239, 240);
              border-radius: 5px;"
              >
            <p class="text-xs text-center">Keine Anmerkungen aufgenommen</p>
          </div>
        </div>  
        <be-footer :ba="ba" :immobilie="immobilie" :lang="lang"/>
      </div>
    </div>
  </pdf-a4-page>
</template>

<script lang="ts">
  import useUser from '@/composables/useUser';
  import Bestandsaufnahme from '@/models/ba/Bestandsaufnahme';
  import Immobilie from '@/models/immobilie.model';
  import { defineComponent, PropType } from 'vue';
  import { useI18n } from 'vue-i18n';
  import moment from 'moment';
  import { useIdentifierFrageFinder } from '@/composables/Bestandsaufnahme/useIdentifierFinder';
  import { getPhotoUrl } from '@/utilities/get-media-url';
  import PdfA4Page from '@/components/Pdf/Components/PdfA4Page.vue';
  import PdfChip from '../Components/PdfChip.vue';
  import { useGesamtflaechen } from './PageElements/useGesamtflaechen';
  import UniversalPdfImageRow from '../Components/UniversalPdfImageRow.vue';
  import IsVorhandenCharAndLabel from './PageElements/isVorhandenCharAndLabel.vue';
  import TngHeader from './PageElements/TngHeader.vue';
  import BeFooter from './PageElements/BeFooter.vue';
  import OnetoFiveImageDiv from './PageElements/OnetoFiveImageDiv.vue';

  export default defineComponent({
    name: 'AllgemeinPage',
    components: {
      PdfA4Page,
      PdfChip,
      UniversalPdfImageRow,
      IsVorhandenCharAndLabel,
      TngHeader,
      BeFooter,
      OnetoFiveImageDiv,
    },
    props: {
      ba: {
        type: Object as PropType<Bestandsaufnahme>,
        required: true,
      },
      immobilie: {
        type: Object as PropType<Immobilie>,
        required: true,
      },
      lang: {
        type: String,
        default: 'de',
      },
    },
    setup(props: any) {
      const { t } = useI18n({ useScope: 'global' });
      const uUser = useUser();
      const { getAnmerkungenPages } = useGesamtflaechen();
      return {
        user: uUser.user,
        t,
        useIdentifierFrageFinder,
        moment,
        getPhotoUrl,
        getAnmerkungenPages,
      };
    },
  });
</script>
<style scoped>
  * {
    color: rgb(23, 68, 81);
    font-family: var(--secondaryFont);
  }

  .pdf-content {
    width: 800px;
    margin: 0 auto;
    color: var(--white100);
  }

  .landingpage-background {
    position: absolute;
    top: 50px;
    left: 50px;
    width: 700px;
    height: 1050px;
    color: var(--black100);
  }

  .trenner {
    height: 1px;
    border-width: 0;
    color: var(--black100);
    background-color: var(--black100);
  }

  .content {
    height: 870px;
  }
</style>
